import { Device } from '../../api/MLFlowApi';

export const NO_DEVICES_VALUE = 'no-devices';
export const NO_DEVICES_LABEL = 'No devices available';

export interface DropdownOption {
  value: string;
  label: string;
}

export const transformDevicesToOptions = (devices: Device[]): DropdownOption[] => {
  if (!devices || devices.length === 0) {
    return [{ value: NO_DEVICES_VALUE, label: NO_DEVICES_LABEL }];
  }
  return devices.map(device => ({
    value: device.device_name,
    label: `${device.device_name} - ${device?.greengrass_status?.status || 'Unknown'}`,
  }));
};

export const transformVersionsToOptions = (versions: any[]): DropdownOption[] => {
  return versions.map(v => ({
    value: v.version,
    label: `v${v.version} — ${v.current_stage || 'N/A'}`,
  }));
};
